import type { Writable } from '@/services/utils';
import type { ModelCancellationTermRequest, OrderServiceApiOrderServiceGetManyRequest } from '@layup/api-sdk';
import type { IPaymentPlan } from './paymentPlans';

export type OrderServiceGetManyRequest = Writable<OrderServiceApiOrderServiceGetManyRequest>;

export enum OrderState {
  PLACED = 'PLACED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  CANCELLING = 'CANCELLING',
  SUSPENDED = 'SUSPENDED',
  EXPIRED = 'EXPIRED',
  PARTIAL = 'PARTIAL',
}

export type Product = {
  _id?: string;
  amount: number;
  link?: string;
  sku: string;
  name?: string;
};

type Benefactor = {
  _id: string;
  name: string;
};

export interface IOrder {
  _id?: string;
  name?: string;
  amountDue: number;
  depositDue: number;
  endDateMax: string;
  endDateMin?: string;
  initiatorId?: string;
  products: Product[];
  state: 'PARTIAL' | 'PLACED' | 'COMPLETED' | 'CANCELLED' | 'CANCELLING' | 'SUSPENDED' | 'EXPIRED';
  supplierId?: string;
  supplier?: { _id: string; name: string };
  plans?: IPaymentPlan[];
  flatFee?: number;
  percFee?: number;
  expire?: string;
  depositPerc: number;
  reference?: string;
  benefactor?: Benefactor;
  enablesSplit?: boolean;
  payments?: any;
  createdAt: string;
  customFeatures?: any;
  cloneCount: number;
  notifications?: any[];
  acceptedProposedCancellationTerms?: boolean;
  cancellationTerms?: ModelCancellationTermRequest;
  orderCancellationRequest?: string;
  depositAmount?: number;
  depositType?: 'PERCENTAGE' | 'FLAT' | 'INSTALMENT';
  merchantTermsLink?: string;
  groupPaymentPlan?: any;
  previewFee?: any;
  debiCheckMinimum?: any;
  orderRefundRequest?: string;
  orderRefundAmount?: number;
  orderRefundFee?: number;
  completedOrderRefundRequest?: boolean;
  isIncreasedDepositAmountAllowed: boolean;
  imageUrl?: string;
  suspendOnCancel?: boolean;
  weeklyPayments?: boolean;
  merchantName: string;
  stateUpdatedAt?: string;
  merchant: string;
  paymentMethods: {
    creditOrDebitCard: boolean;
    eft: boolean;
    debiCheck: boolean;
    payAt: boolean;
    capitecPay: boolean;
    dashpay: boolean;
    terminalCard: boolean;
    offline: boolean;
    embeddedCheckout: boolean;
  };
  type: string;
  merchantId?: string;
}

export interface OrderErrors {
  name: string;
  reference: string;
  amountDue: string;
  depositType: string;
  depositPerc: string;
  depositAmount: string;
  orderExpiryDuration: string;
  orderExpiryTimeUnit: string;
  endDate: string;
  travelDate: string;
}

export interface CloningErrors {
  cloningExpiryDuration: string;
  cloningExpiryTimeUnit: string;
  cloningLimit: string;
}

export interface IOrderShareRequest {
  data: {
    type?: string;
    orderId?: string;
    orderUrl?: string;
    contact?: string;
    message?: string;
    sendType?: 'email' | 'sms';
  };
}
